var team = {};
module['exports'] = team;
team.creature = require("./creature");
team.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/team/index.js
// module id = 975
// module chunks = 0